const lazyLoad = (el) => {
    
    const config = {
        rootMargin: '0px',
        threshold: 0,
    };
  
    const lazy = new IntersectionObserver(entries => {
        entries.map(entry => {
            if (!entry.isIntersecting) return false
            
            //DO STUFF
            console.log(entry);
        })
    }, config)

    lazy.observe(el);

};

export default lazyLoad;